<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>{{ info.storeName }}</h1>
    </div>
    <b-card>
      <b-row class="gx-2">
        <b-col md="2">
          <MenuInner
            :activeItem="activeItem"
            :DetailMenus="DetailMenus"
            :id="id"
            :maId="id"
            :maName="info.storeName"
          >
          </MenuInner>
        </b-col>
        <b-col md="10">
          <div>
            <h3>Lịch sử cập nhật thông tin cửa hàng</h3>
            <b-table
              hover
              sticky-header
              responsive
              :items="historyConfig"
              :fields="fieldsConfig"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
              style="margin-top: 10px"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>

              <template #cell(createdDate)="{ item }">
                <div v-if="item?.createdDate">
                  {{ formatDate(item?.createdDate) }}
                </div>
              </template>

              <template #cell(before)="{ item }">
                <div v-if="item?.before && item?.after">
                  <div
                    v-for="field in getChangedFields(item)"
                    :key="field"
                    class="mb-2 p-2 bg-light border-left-danger"
                  >
                    <div class="field-name text-muted">{{ formatFieldName(field) }}</div>
                    <div class="field-value">
                      <div v-if="Array.isArray(item.before[field])">
                        <div v-if="item.before[field].length === 0" class="text-muted">Trống</div>
                        <div v-for="(val, index) in item.before[field]" :key="index" class="mb-1">
                          <img
                            v-if="isImageUrl(val)"
                            :src="val"
                            alt="image"
                            class="preview-image"
                          />
                          <span v-else>{{ formatFieldValue(val) }}</span>
                        </div>
                      </div>
                      <div
                        v-else-if="
                          typeof item.before[field] === 'object' && item.before[field] !== null
                        "
                      >
                        <div v-for="(subValue, subKey) in item.before[field]" :key="subKey">
                          {{ formatFieldValue(subValue) }}
                        </div>
                      </div>
                      <div v-else>{{ formatFieldValue(item.before[field]) }}</div>
                    </div>
                  </div>
                </div>
                <div v-else-if="!item?.after" class="text-muted">Không có dữ liệu</div>
                <div v-else>Không có thay đổi</div>
              </template>

              <template #cell(after)="{ item }">
                <div v-if="item?.before && item?.after">
                  <div
                    v-for="field in getChangedFields(item)"
                    :key="field"
                    class="mb-2 p-2 bg-light border-left-success"
                  >
                    <div class="field-name text-muted">{{ formatFieldName(field) }}</div>
                    <div class="field-value">
                      <div v-if="Array.isArray(item.after[field])">
                        <div v-if="item.after[field].length === 0" class="text-muted">Trống</div>
                        <div v-for="(val, index) in item.after[field]" :key="index" class="mb-1">
                          <img
                            v-if="isImageUrl(val)"
                            :src="val"
                            alt="image"
                            class="preview-image"
                          />
                          <span v-else>{{ formatFieldValue(val) }}</span>
                        </div>
                      </div>
                      <div
                        v-else-if="
                          typeof item.after[field] === 'object' && item.after[field] !== null
                        "
                      >
                        <div v-for="(subValue, subKey) in item.after[field]" :key="subKey">
                          {{ formatFieldValue(subValue) }}
                        </div>
                      </div>
                      <div v-else>{{ formatFieldValue(item.after[field]) }}</div>
                    </div>
                  </div>
                </div>
                <div v-else-if="!item?.before" class="text-muted">Không có dữ liệu</div>
                <div v-else>Không có thay đổi</div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { GetHistoryRenameStore } from '@/services/customer-support/store'
  import { showMess } from '@/config/utils'
  import { asignType } from '@/pages/customer-support/cskh/account/components/constant'
  import MenuInner from '@/pages/customer-support/cskh/account/components/MenuInner.vue'
  import { DetailMenus } from '@/pages/customer-support/cskh/store/components/constant'
  import { CommonService } from '@/services/common.service'

  export default {
    name: 'HistoryRenameAssignStore',
    components: { MenuInner },
    data() {
      return {
        DetailMenus,
        asignType,
        isLoading: false,
        activeItem: 'list_history_rename',
        id: '',
        info: [],
        historyAssign: [],
        historyConfig: [],
        fieldsAssign: [],
        fieldsConfig: [
          {
            key: 'before',
            label: 'Thông tin cũ',
            sortable: false,
            thStyle: 'width: 100px; text-align: center',
          },
          {
            key: 'after',
            label: 'Thông tin mới',
            sortable: false,
            thStyle: 'width: 80px; text-align: center',
          },
          {
            key: 'createdByName',
            label: 'Người cập nhật',
            sortable: false,
            thStyle: 'width: 80px; text-align: center',
          },
          {
            key: 'createdDate',
            label: 'Thời gian',
            sortable: false,
            thStyle: 'width: 80px; text-align: center',
          },
        ],
        listStatus: [],
      }
    },
    created() {
      this.id = this.$router.currentRoute.params.id
    },
    async mounted() {
      await this.configSystem()
      this.getHistoryAssign()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.listStatus = data.data.storeStatus.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                  name: item.name,
                  bgColor: item.bgColor,
                  class: item?.class ?? 'text-primary',
                }
              })
            }
          })
          .catch(error => console.error(error))
      },
      getChangedFields(item) {
        if (!item.before || !item.after) return []

        const changedFields = []
        const allFields = new Set([...Object.keys(item.before), ...Object.keys(item.after)])

        allFields.forEach(field => {
          const beforeValue = item.before[field]
          const afterValue = item.after[field]

          if (!this.isEqual(beforeValue, afterValue)) {
            changedFields.push(field)
          }
        })

        return changedFields
      },

      isEqual(value1, value2) {
        // So sánh null/undefined
        if (value1 === value2) return true
        if (value1 == null || value2 == null) return false

        // So sánh array
        if (Array.isArray(value1) && Array.isArray(value2)) {
          if (value1.length !== value2.length) return false
          return value1.every((item, index) => this.isEqual(item, value2[index]))
        }

        // So sánh object
        if (typeof value1 === 'object' && typeof value2 === 'object') {
          const keys1 = Object.keys(value1)
          const keys2 = Object.keys(value2)

          if (keys1.length !== keys2.length) return false

          return keys1.every(key => this.isEqual(value1[key], value2[key]))
        }

        // So sánh primitive values
        return value1 === value2
      },

      formatFieldName(fieldName) {
        const fieldMap = {
          storeName: 'Tên cửa hàng',
          address: 'Địa chỉ',
          regionCode: 'Mã vùng',
          provinceCode: 'Mã tỉnh/thành',
          districtCode: 'Mã quận/huyện',
          regionName: 'Tên vùng',
          provinceName: 'Tỉnh/Thành phố',
          districtName: 'Quận/Huyện',
          status: 'Trạng thái',
          images: 'Hình ảnh',
          verificationImage: 'Ảnh xác minh',
          createdStoreDate: 'Ngày tạo cửa hàng',
        }

        return (
          fieldMap[fieldName] ||
          fieldName
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase())
            .trim()
        )
      },

      formatFieldValue(value) {
        if (value === null || value === undefined || value === '') {
          return ''
        }

        if (typeof value === 'boolean') {
          return value ? 'Có' : 'Không'
        }

        // Lấy status từ listStatus config
        if (typeof value === 'string' && this.listStatus && this.listStatus.length > 0) {
          const statusItem = this.listStatus.find(status => status.id === value)
          if (statusItem) {
            return statusItem.name
          }
        }

        if (typeof value === 'string' && this.isDateString(value)) {
          return this.formatDate(value)
        }

        if (typeof value === 'number') {
          return value.toLocaleString('vi-VN')
        }

        return value
      },

      isDateString(str) {
        if (typeof str !== 'string') return false
        return str.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/) !== null
      },

      isImageUrl(url) {
        if (typeof url !== 'string') return false
        return (
          url.match(/\.(jpeg|jpg|gif|png|bmp|webp)$/i) ||
          url.includes('amazonaws.com') ||
          url.includes('cloudinary.com') ||
          url.includes('firebase') ||
          url.includes('image')
        )
      },

      formatDate(dateString) {
        if (!dateString) return ''
        try {
          const date = new Date(dateString)
          if (isNaN(date.getTime())) return dateString

          return date.toLocaleString('vi-VN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })
        } catch (e) {
          return dateString
        }
      },

      async getHistoryAssign() {
        try {
          this.isLoading = true
          const res = await GetHistoryRenameStore({
            id: this.id,
          })
          if (res.code === 1000) {
            this.historyConfig = res.data
          }
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
